import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getCore } from '@dynamic-labs-sdk/client/core';

type BaseAccountAppMetadata = {
  appLogoUrl: string | undefined;
  appName: string;
};

/**
 * Reads the customer-supplied app name and logo from the Dynamic client.
 * Mirrors the lookup used by `createSignClient` in `@dynamic-labs-sdk/wallet-connect`
 * — preferring `core.metadata` (set on the client) over project-settings fallbacks.
 *
 * Used by the Base Account EVM extension so callers do not have to repeat
 * values they already passed to `createDynamicClient`.
 *
 * @param client - The Dynamic client whose configuration drives the result.
 * @not-instrumented
 */
export const getBaseAccountAppMetadata = (
  client: DynamicClient
): BaseAccountAppMetadata => {
  const core = getCore(client);
  const generalSettings = client.projectSettings?.general;

  return {
    appLogoUrl:
      core.metadata?.iconUrl ?? generalSettings?.appLogo ?? undefined,
    appName: core.metadata?.name ?? generalSettings?.displayName ?? '',
  };
};
